import Basic from "./Basic"
import Simple from "./Simple"
import AntDesignTable from "./AntDesignTable";

export default {
    Basic,
    Simple,
    AntDesignTable
};